import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Constants } from '../../common';

interface Toaster {
  type: 'success' | 'error' | 'warning';
  message: string;
  visible: boolean;
  timer?: ReturnType<typeof setTimeout>;
  linkText?: string;
  linkCallback?: () => void;
}

@Component({
    selector: 'app-zignflix-toaster',
    imports: [
        CommonModule
    ],
    templateUrl: './zignflix-toaster.component.html',
    styleUrl: './zignflix-toaster.component.scss',
    animations: [
        trigger('toasterAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-20px)' }),
                animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
            ])
        ]),
        trigger('hoverAnimation', [
            state('default', style({ transform: 'scale(1)' })),
            state('hovered', style({ transform: 'scale(1.05)' })),
            transition('default <=> hovered', animate('200ms ease-in-out'))
        ])
    ]
})
export class ZignflixToasterComponent {
  toaster: Toaster | null = null;
  isHovered = false;

  constructor(private cdr: ChangeDetectorRef) { }

  success(message: string) {
    this.showToaster('success', message);
  }

  error(message: string) {
    this.showToaster('error', message);
  }

  warning(message: string) {
    this.showToaster('warning', message);
  }

  successWithLink(message: string, linkText: string, linkCallback: () => void) {
    this.showToaster('success', message, linkText, linkCallback);
  }  

  private showToaster(type: 'success' | 'error' | 'warning', message: string, linkText?: string, linkCallback?: () => void) {
    if (this.toaster) clearTimeout(this.toaster.timer);

    this.toaster = { type, message, visible: true, linkText, linkCallback };
    this.cdr.detectChanges();

    this.toaster.timer = setTimeout(() => {
      if (this.toaster?.visible) {
        this.toaster.visible = false;
        this.cdr.detectChanges();
      }
    }, Constants.toasterTimeout);
  }
  

  onMouseEnter() {
    this.isHovered = true;
    if (this.toaster) clearTimeout(this.toaster.timer);
  }

  onMouseLeave() {
    this.isHovered = false;
    if (this.toaster) {
      this.toaster.timer = setTimeout(() => {
        this.toaster!.visible = false;
        this.cdr.detectChanges();
      }, Constants.toasterTimeout);
    }
  }

  onLinkClick(event: MouseEvent) {
    event.preventDefault();
    if (this.toaster?.linkCallback) {
      this.toaster.linkCallback();
    }
  }
  
  
}
